import { render, staticRenderFns } from "./edit-dialog.vue?vue&type=template&id=e8be95f0"
import script from "./edit-dialog.vue?vue&type=script&lang=js"
export * from "./edit-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports